import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import PropTypes from 'prop-types';

// Components
import { Mui, MuiLab } from 'components';
import { EmptyState, EskolareBadge } from 'components/common';

const SWATCH_VARIANTS = ['green', 'blue', 'orange', 'red'];
const SKELETON_ROWS = [0, 1, 2];

function ArticleRow(props) {
  const { article, variant, to } = props;

  return (
    <Mui.ListItem
      button
      component={RouterLink}
      to={to}
      target="_blank"
      rel="noopener noreferrer"
      divider>
      <Mui.Box mr={2}>
        <EskolareBadge variant={variant} />
      </Mui.Box>
      <Mui.ListItemText
        primary={article?.title}
        primaryTypographyProps={{ style: { fontWeight: 700 } }}
        secondary={article?.section?.name}
      />
      <Mui.ListItemSecondaryAction>
        <Mui.Icon>navigate_next</Mui.Icon>
      </Mui.ListItemSecondaryAction>
    </Mui.ListItem>
  );
}

ArticleRow.propTypes = {
  article: PropTypes.object,
  variant: PropTypes.string,
  to: PropTypes.string,
};

export function ArticlesEmptyState(props) {
  const { search } = props;

  return (
    <EmptyState.Results
      customIcon={<EskolareBadge variant="brand" size={76} />}
      title={search ? 'Nenhum artigo encontrado' : 'Nenhum artigo disponível'}
      description={
        search
          ? `Não encontramos resultados para "${search}"`
          : 'Não há artigos disponíveis no momento'
      }
    />
  );
}

ArticlesEmptyState.propTypes = {
  search: PropTypes.string,
};

export function ArticlesListSkeleton() {
  return (
    <Mui.List dense disablePadding>
      {SKELETON_ROWS.map(index => (
        <Mui.ListItem key={index} divider>
          <Mui.Box mr={2}>
            <EskolareBadge variant={SWATCH_VARIANTS[index % SWATCH_VARIANTS.length]} />
          </Mui.Box>
          <Mui.ListItemText
            primary={<MuiLab.Skeleton variant="text" width="70%" />}
            secondary={<MuiLab.Skeleton variant="text" width="40%" />}
          />
        </Mui.ListItem>
      ))}
    </Mui.List>
  );
}

function ArticlesList(props) {
  const { articles, context, slug, search } = props;

  if (!Array.isArray(articles) || articles.length === 0) {
    return <ArticlesEmptyState search={search} />;
  }

  return (
    <Mui.List dense disablePadding>
      {articles.map((article, index) => (
        <ArticleRow
          key={article?.uid}
          article={article}
          variant={SWATCH_VARIANTS[index % SWATCH_VARIANTS.length]}
          to={`/${context}/${slug}/support/platform-articles/${article?.slug}`}
        />
      ))}
    </Mui.List>
  );
}

ArticlesList.propTypes = {
  articles: PropTypes.array,
  context: PropTypes.oneOf(['sellers', 'institutions']),
  slug: PropTypes.string,
  search: PropTypes.string,
};

export default ArticlesList;
